import React, { useEffect, useState } from "react";
import { useParams, NavLink } from "react-router-dom";
import axios from "axios";
import slugify from "../utils/slugify";
import Breadcrumb from "../components/Breadcrumb";
import { useTranslation } from "react-i18next";

function OperaHousesByCity() {
  const { city } = useParams();
  const [venues, setVenues] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [heroImage, setCurrentHeroImage] = useState(
    "/images/default-opera.jpg"
  );
  const { t } = useTranslation();

  const toTitleCase = (str) =>
    str
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  const fetchCityData = React.useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get("/api/cities");

      const cityImage = res.data.filter(
        (c) => c.name && slugify(toTitleCase(c.name)) === city
      );
      console.log("City data:", cityImage);
      setCurrentHeroImage(cityImage[0]?.image || "/images/default-opera.jpg");
      setLoading(false);
    } catch (err) {
      setError(t('OperaHousesByCity.error'));
      setLoading(false);
    }
  }, []);
  const fetchVenues = React.useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get("/api/venues", {
        timeout: 15000,
      });

      const filteredVenues = res.data.filter(
        (v) =>
          v?.cityNew?.name &&
          slugify(toTitleCase(v.cityNew.name)) === city &&
          v.published === true
      );

      setVenues(filteredVenues);
      setError(null);
      setLoading(false);
    } catch (err) {
      setError(t('OperaHousesByCity.errorTwo'));
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchVenues();
    fetchCityData();
  }, [city, fetchVenues, fetchCityData]);

  const handleRetry = () => {
    setLoading(true);
    setError(null);
    fetchVenues();
  };
  if (loading)
    return <p className="text-black text-center">{t('OperaHousesByCity.loading')}</p>;
  if (error)
    return (
      <div className="text-center">
        <p className="text-black">{error}</p>
        <button
          onClick={handleRetry}
          className="mt-4 bg-[#8C0000] text-white px-4 py-2 text-sm hover:bg-[#B20000] transition-colors"
        >
          {t('OperaHousesByCity.error')}
        </button>
      </div>
    );
  if (!venues.length)
    return (
      <p className="text-black text-center">{t('OperaHousesByCity.noVenues')}</p>
    );
  const cityName = toTitleCase(city);

  return (
    <div className="bg-white">
      <div className="relative w-full h-[280px] md:h-[33vw] overflow-hidden">
        <img
          src={heroImage}
          alt={toTitleCase(city)}
          className="w-full h-full object-cover object-center"
        />
      </div>
      <Breadcrumb
        items={[
          { href: "/", label: "Home" },
          {
            href: "/opera-houses-and-festivals",
            label: "Destinations",
          },
          {
            href: "#",
            label: cityName ? cityName : "",
          },
        ]}
      />
      <main className="max-w-[1280px] mx-auto px-4 py-8">
        <h1 className="text-4xl mb-8 text-center md:text-left">
          {t('OperaHousesByCity.operaHousesIn')} {toTitleCase(city)}
        </h1>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
          {venues.length > 0 &&
            venues.map((venue) => {
              if (!venue.name) return null;

              const venueDestination = `/${slugify(venue.name)}`;

              return (
                <div key={venue._id} className="w-full mb-8">
                  <p
                    className="text-xl text-black font-light text-left normal-case mb-2 font-cinzel"
                    style={{ textTransform: "none" }}
                  >
                    {venue.name}
                  </p>
                  <NavLink
                    to={venueDestination}
                    className="block w-full md:w-[400px] h-[228px] relative shadow-md transition-transform hover:scale-[1.01] mx-auto"
                  >
                    {venue.coverImage ? (
                      <>
                        <img
                          src={venue.coverImage}
                          alt={venue.name}
                          className="w-full h-full object-cover"
                        />
                        <div className="absolute bottom-0 left-0 p-2 w-full bg bg-gradient-mask">
                          <span className="text-white font-normal text-lg uppercase">
                            {venue.name}
                          </span>
                        </div>
                      </>
                    ) : (
                      <div className="w-full h-full bg-white relative flex items-center justify-center">
                        <span className="absolute bottom-0 left-0 p-2 text-black font-normal text-lg uppercase">
                          {venue.name}
                        </span>
                      </div>
                    )}
                  </NavLink>
                </div>
              );
            })}
        </div>
      </main>
    </div>
  );
}

export default OperaHousesByCity;
